import React, { useState, useEffect } from 'react';

const API = 'http://111.88.156.8:8000/api/v1';

function Analytics() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(API + '/analytics')
      .then(r => r.json())
      .then(setData);
  }, []);

  if (!data) return <p style={{color:'#94A3B8'}}>Loading...</p>;

  const m = data.metrics;
  const funnel = data.funnel;
  const maxCount = Math.max(...funnel.map(f => f.count), 1);

  return (
    <div>
      <h2>Analytics Dashboard</h2>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10, marginTop: 12, marginBottom: 20 }}>
        <div style={cardStyle}><div style={labelStyle}>CAC</div><div style={valueStyle}>{m.cac.toLocaleString()} ₽</div></div>
        <div style={cardStyle}><div style={labelStyle}>LTV</div><div style={valueStyle}>{m.ltv.toLocaleString()} ₽</div></div>
        <div style={cardStyle}><div style={labelStyle}>LTV/CAC</div><div style={valueStyle}>{m.ltv_cac_ratio}</div></div>
        <div style={cardStyle}><div style={labelStyle}>MRR</div><div style={valueStyle}>{m.mrr.toLocaleString()} ₽</div></div>
        <div style={cardStyle}><div style={labelStyle}>ARR Forecast</div><div style={valueStyle}>{m.arr_forecast.toLocaleString()} ₽</div></div>
        <div style={cardStyle}><div style={labelStyle}>Churn Rate</div><div style={valueStyle}>{m.churn_rate}</div></div>
      </div>

      <h3 style={{ marginBottom: 12 }}>Conversion Funnel</h3>
      {funnel.map((f, i) => (
        <div key={i} style={{ marginBottom: 8 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 4 }}>
            <span>{f.stage}</span>
            <span style={{ color: '#94A3B8' }}>{f.count}</span>
          </div>
          <div style={{ background: '#334155', borderRadius: 4, height: 20, overflow: 'hidden' }}>
            <div style={{ width: (f.count / maxCount * 100) + '%', height: '100%', background: i === 0 ? '#6366F1' : i === 1 ? '#8B5CF6' : i === 2 ? '#10B981' : '#F59E0B', borderRadius: 4 }} />
          </div>
        </div>
      ))}
    </div>
  );
}

const cardStyle = { background: '#1E293B', padding: 14, borderRadius: 8, border: '1px solid #334155', textAlign: 'center' };
const labelStyle = { fontSize: 10, color: '#94A3B8', textTransform: 'uppercase', marginBottom: 4 };
const valueStyle = { fontSize: 16, fontWeight: 700 };

export default Analytics;